var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsWholeLotUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_319_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z",
    fill: "#EF814E",
    stroke: "#EF814E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8974 21.0004C15.5004 21.0004 16.8 19.661 16.8 18.0088C16.8 16.8892 16.2032 15.9133 15.3196 15.4004L11.2 19.1157C11.6269 20.22 12.6737 21.0004 13.8974 21.0004Z",
    fill: "#6C2C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1026 21.0004C24.4996 21.0004 23.2 19.661 23.2 18.0088C23.2 16.8892 23.7968 15.9133 24.6804 15.4004L28.8 19.1157C28.3731 20.22 27.3263 21.0004 26.1026 21.0004Z",
    fill: "#6C2C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 25.8337C25.1686 25.318 24.2928 24.8978 23.2784 24.608C22.264 24.3182 21.1402 24.167 20 24.167C18.8597 24.167 17.7359 24.3182 16.7215 24.608C15.7071 24.8978 14.8313 25.318 14.1666 25.8337",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.38 11.7838C26.7377 13.3374 27.6858 13.8848 29.7101 14.2838",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6235 11.7838C13.2658 13.3374 12.3178 13.8848 10.2934 14.2838",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_1328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsWholeLotUnselected);
export default __webpack_public_path__ + "static/media/hurts-whole-lot-unselected.7595754b3d96bd7991eea7e48e5b7a3c.svg";
export { ForwardRef as ReactComponent };